import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getListModule,
  getListModuleSupport,
  PostDataScorm
} from "../../../../../../../../api/repositories";
import { setInvalidToken } from "../../../../../../../../redux/features/main/invalidTokenSlice";

import { clearDataForm } from "../../../../../../../../utils";

import { useTranslation } from "react-i18next";

const useActions = (
  loadingLP,
  journeyId,
  courseId,
  currModuleId,
  setModuleStream,
  setIdxOpenedModule,
  hiddenClick,
  setHiddenClick,
  setLinkStream,
  reFetchLeftSection,
  isMobileVersion,
  mainState,
  setResyncBtn,
  setBtnText
) => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.notification.userId);
  const backLoad = useSelector((state) => state.learning_journey.backLoad);

  const { t, i18n } = useTranslation();
  const [loadingModule, setLoadingModule] = useState(true);
  const [currModule, setCurrModule] = useState([]);
  const [listCurrModule, setListCurrModule] = useState([]);
  const [loadingSendScorm, setLoadingSendScorm] = useState(false);

  let navigate = useNavigate();

  const url = window.location.pathname;
  const arrId = url.split("/");
  const courseIdPosition = arrId.indexOf("course");
  const currentCourseId =
    courseIdPosition > -1 && parseInt(arrId[courseIdPosition + 1]);

  const moduleidPosition = arrId.indexOf("module");
  const currentModuleId =
    moduleidPosition > -1 && parseInt(arrId[moduleidPosition + 1]);

  const modulesupPosition = arrId.indexOf("supporting");
  const currentModuleSupId =
    modulesupPosition > -1 && parseInt(arrId[modulesupPosition + 1]);

  const getListCurrModule = async () => {
    try {
      const { data, status } = await getListModule(journeyId, currentCourseId);
      dispatch(setInvalidToken(status));
      setListCurrModule(data);
      findModule(data, currentModuleId);
    } catch (err) {
      setListCurrModule(null);
    } finally {
    }
  };

  // fungsi send data scorm sementara
    const sendScormData = async (datascorm, scormLocalStorageKey, urlnavigate) => {
      setLoadingSendScorm(true);
      
      const dataOrder = orderingDataSendScorm(JSON.parse(datascorm.value))

      const payloadSend = {
        "userid": userId,
        "scormid": currModule.scorm_id,
        "scoid": currModule.sco_id,
        "timemodified": Date.now(),
        "data": dataOrder
      }

      // console.log(payloadSend)

      if (!Array.isArray(payloadSend.data) || payloadSend.data.length === 0) {
        mainState.setMessageSnack("Received invalid or corrupted data. Please contact customer support for assistance.");
        mainState.setOpenedSnack(true);
        setLoadingSendScorm(false)
        setResyncBtn(false)
        setBtnText(t("feature.feature_mylj.main_content.enter"))
        clearDataForm(scormLocalStorageKey);
      } else {
        try {
          const { data, status } = await PostDataScorm({data: payloadSend});
          dispatch(setInvalidToken(status));

          if(status === 200){
            mainState.setMessageSnack("Success Send SCORM data");
            mainState.setOpenedSnack(true);
            clearDataForm(scormLocalStorageKey)
            setResyncBtn(false)
            setBtnText(t("feature.feature_mylj.main_content.enter"));
            // navigate(urlnavigate);
          } else {
            mainState.setMessageSnack("Failed Send SCORM data, Please re-sync");
            mainState.setOpenedSnack(true);
          }
          
        } catch (err) {
          mainState.setMessageSnack("Failed Send SCORM data, Please re-sync");
          mainState.setOpenedSnack(true);
        } finally {
          setLoadingSendScorm(false)
        }
      }
    };

    const orderingDataSendScorm = (data) => {
      // clone biar tidak merusak array asli
      let arr = [...data];

      // 🚫 buang student_id & student_name
      arr = arr.filter(item => 
        item.element !== "cmi.core.student_id" && 
        item.element !== "cmi.core.student_name"
      );

      // helper untuk cari index element
      const findElement = (key) => arr.findIndex(item => item.element === key);

      // Pisahkan dulu berdasarkan kategori yang ada
      let lessonStatusIncomplete = arr.filter(item => item.element === "cmi.core.lesson_status" && item.value === "incomplete");
      let lessonStatusOther = arr.filter(item => item.element === "cmi.core.lesson_status" && item.value !== "incomplete");
      let coreExit = arr.filter(item => item.element === "cmi.core.exit");
      let scoreRaw = arr.filter(item => item.element === "cmi.core.score.raw");
      let sessionTime = arr.filter(item => item.element === "cmi.session_time");

      // Interactions (result & student_response) -> group by index
      let interactions = arr.filter(item => item.element.startsWith("cmi.interactions."));
      interactions.sort((a, b) => {
        // extract angka index di tengah element
        const getIndex = (el) => {
          let match = el.match(/^cmi\.interactions\.(\d+)\./);
          return match ? parseInt(match[1], 10) : Infinity;
        };
        return getIndex(a.element) - getIndex(b.element);
      });

      // Sisanya (yang tidak masuk kategori khusus)
      let others = arr.filter(item =>
        !lessonStatusIncomplete.includes(item) &&
        !lessonStatusOther.includes(item) &&
        !coreExit.includes(item) &&
        !scoreRaw.includes(item) &&
        !sessionTime.includes(item) &&
        !interactions.includes(item)
      );

      // Mulai rakit array hasil sesuai aturan
      let result = [];

      // 1. lesson_status incomplete ke paling atas
      result.push(...lessonStatusIncomplete);

      // 2. others dulu
      result.push(...others);

      // 3. interactions urut sesuai index
      result.push(...interactions);

      // 4. sessionTime, scoreRaw, lessonStatusOther, coreExit
      if (scoreRaw.length > 0) {
        result.push(...sessionTime);
        result.push(...scoreRaw);
      } 

      // lessonStatus selain incomplete → sebelum exit
      result.push(...lessonStatusOther);

      // sessionTime (jika belum masuk di atas dan ada)
      if (scoreRaw.length === 0) {
        result.push(...sessionTime);
      }

      // terakhir core.exit
      result.push(...coreExit);

      return result;
    };


  const getListCurrModuleSupp = async () => {
    try {
      const { data, status } = await getListModuleSupport(
        journeyId,
        currentCourseId,
      );
      dispatch(setInvalidToken(status));
      setListCurrModule(data);
      findModule(data, currentModuleSupId);
    } catch (err) {
      setListCurrModule(null);
    } finally {
    }
  };

  const findModule = (data, currId) => {
    const selectedModule = data.modules
      .sort((a, b) => parseInt(a.id) - parseInt(b.id))
      .find((item) => item.id === currId);

    data.modules
      .sort((a, b) => parseInt(a.id) - parseInt(b.id))
      .map((item, idx) => {
        if (item.id === currId) setIdxOpenedModule(item.summary);
      });

    // setLinkStream(selectedModule.stream_url)
    setCurrModule(selectedModule);
    setModuleStream(selectedModule);
    setHiddenClick(null);

    setLoadingModule(false);
  };

  useEffect(() => {
    if (isMobileVersion) {
      if (
        loadingLP === false &&
        moduleidPosition > -1 &&
        currentModuleId &&
        reFetchLeftSection === false
      ) {
        getListCurrModule();
      }

      if (
        loadingLP === false &&
        modulesupPosition > -1 &&
        currentModuleSupId &&
        reFetchLeftSection === false
      ) {
        getListCurrModuleSupp();
      }
    } else {
      if (
        loadingLP === false &&
        moduleidPosition > -1 &&
        hiddenClick == currentModuleId &&
        reFetchLeftSection === false
      ) {
        getListCurrModule();
      }

      if (
        loadingLP === false &&
        modulesupPosition > -1 &&
        hiddenClick == currentModuleSupId &&
        reFetchLeftSection === false
      ) {
        getListCurrModuleSupp();
      }
    }
  }, [loadingLP, currModuleId, hiddenClick, reFetchLeftSection]);

  useEffect(() => {
    if(backLoad){
      if (
        moduleidPosition > -1
      ) {
        getListCurrModule();
      }

      if (
        modulesupPosition > -1
      ) {
        getListCurrModuleSupp();
      }
    }
  },[backLoad])

  return {
    currModule,
    loadingModule,
    sendScormData,
    loadingSendScorm
  };
};

export default useActions;
